import React from "react";

import { Box } from "@mui/material";


const SkeletonLoader = () => (
    <Box sx={{ width: "100%" }}>
        {[1, 2, 3, 4, 5].map((item) => (
            <Box
                key={item}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    py: 2,
                    borderBottom: '1px solid #F0F4F8',
                }}
            >
                <Box sx={{ width: "100%" }}>
                    <Box
                        sx={{
                            height: 14,
                            width: "70%",
                            backgroundColor: "#F0F4F8",
                            borderRadius: "4px",
                            mb: 1
                        }}
                    />
                    <Box
                        sx={{
                            height: 12,
                            width: "40%",
                            backgroundColor: "#F0F4F8",
                            borderRadius: "4px"
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        width: 24,
                        height: 24,
                        backgroundColor: "#F0F4F8",
                        borderRadius: "50%"
                    }}
                />
            </Box>
        ))}
    </Box>
);

export default SkeletonLoader;
